import { sql } from "drizzle-orm";

export function workflowJsonb(value: unknown): ReturnType<typeof sql> {
  const json = JSON.stringify(value ?? {});
  return sql`${json}::text::jsonb`;
}
